module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../lodash/first.js
// module id = 1119
// module chunks = 22